/* eslint-disable no-underscore-dangle */
import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import Locale from "../../locales";
import "./SessionsList.css";
import SessionItem from "./SessionItem/SessionItem";

const SessionsList = () => {
  const sessions = useSelector((state) => state.teacherReducer.sessions);

  const sortedSessions = sessions.sort((left, right) => {
    return moment(left.startTime, "hh:mm:ss").diff(
      moment(right.startTime, "hh:mm:ss"),
      "seconds",
    );
  });
  return (
    <div className="sessions-tasks-list-container">
      <div className="heading-container">
        <h1 className="sessions-tasks-list-header-text">
          {Locale.t("current_sessions_overview")}
        </h1>
      </div>
      <div className="section-container main-section">
        {sortedSessions.map((session) => (
          <SessionItem key={session.sessionId} session={session} />
        ))}
        {sessions.length === 0 && (
          <div className="no-sessions-scheduled-container">
            <h3>No Sessions have been scheduled</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default SessionsList;
